const AI_USAGE_HASH_PREFIX = 'ai-usage-'

export const AI_FLUENCY_SECTION_ANCHOR = 'ai-fluency'

export const projectAnchor = projectId => `project-${projectId}`

// Names the type clicked rather than a destination: a card cannot tell whether that type is
// explained in the AI fluency section or only on a project.
export const buildAiUsageHash = usageType => `#${AI_USAGE_HASH_PREFIX}${usageType}`

export const parseAiUsageHash = hash => {
  const fragment = (hash ?? '').replace(/^#/, '')

  return fragment.startsWith(AI_USAGE_HASH_PREFIX) ? fragment.slice(AI_USAGE_HASH_PREFIX.length) : null
}
